import { observer } from 'mobx-react-lite'
import { DeleteBillingMethodDialog } from '@/features/billing/payment-methods/DeleteBillingMethodDialog'
import { type DeleteBillingMethodDialogViewModel } from './DeleteBillingMethodDialogViewModel'

export interface DeleteBillingMethodDialogContainerProps {
  vm: DeleteBillingMethodDialogViewModel
}

export const DeleteBillingMethodDialogContainer = observer(
  function DeleteBillingMethodDialogContainer({
    vm,
  }: DeleteBillingMethodDialogContainerProps) {
    return (
      <DeleteBillingMethodDialog
        showing={vm.modal.showing}
        onConfirm={vm.delete}
        onDecline={vm.cancel}
      />
    )
  },
)
